<template>
  <Popover ref="panelPopover" :showHeader="true" :headerTitle="`Panel ${barcode}`">
    <div class="production-preview-panel-popover" v-if="panel && orderItem">
      <div class="row">
        <div class="col-6 panel-popover-display">
          <div class="font-weight-bold">Status</div>
          <div>{{panel.status | formatLookupName(ProductionPanelStatusTypeLookup)}}</div>
          <div class="font-weight-bold">Size</div>
          <div>{{panel.panelHeight}}x{{panel.panelWidth}}</div>
          <div class="font-weight-bold">Stock</div>
          <div>{{panel.orderItem.stock.code}} - {{panel.orderItem.stock.name}}</div>
          <div class="font-weight-bold">System Creation Time</div>
          <div>{{panel.createdAt | formatDateTime}}</div>
          <div class="font-weight-bold">Production Due</div>
          <div>{{panel.dateProductionDue | formatDateTime}}</div>
          <div class="font-weight-bold">Despatch Due</div>
          <div>{{panel.dateDespatchDue | formatDateTime}}</div>
          <template v-if="panel.dateProductionCompleted">
            <div class="font-weight-bold">Completed Production</div>
            <div>{{panel.dateProductionCompleted | formatDateTime}}</div>
          </template>
          <template v-if="panel.dateCompleted">
            <div class="font-weight-bold">Completed</div>
            <div>{{panel.dateCompleted | formatDateTime}}</div>
          </template>
          <template v-if="tougheningBatch">
            <div class="font-weight-bold">Toughening Batch</div>
            <div><LinkTougheningBatch :id="tougheningBatch.id" :name="`#${tougheningBatch.sequenceNumber}`" /></div>
          </template>
          <template v-if="optimiserSheet">
            <div class="font-weight-bold">Optimiser Sheet</div>
            <div><LinkOptimiserSheet :id="optimiserSheet.id" :name="`Sheet ${optimiserSheet.id}`" /></div>
          </template>
          <template v-if="!isPanelCancelled && !isPanelCompleted && panel.currentSupplier">
            <div class="font-weight-bold">Current Location</div>
            <div>
              <LinkContact :id="panel.currentSupplier.id" :name="panel.currentSupplier.name" />
            </div>
          </template>
          <template v-if="!isPanelCancelled && !isPanelCompleted && !panel.currentSupplier && panel.inventoryBin">
            <div class="font-weight-bold">Current Location</div>
            <div>
              {{panel.inventoryBin.code}} | {{panel.inventoryBin.accountLocation.name}}
            </div>
          </template>
          <template v-if="panel.isPendingTransfer && !isPanelCompleted">
            <div class="font-weight-bold">Pending Transfer</div>
            <div>Yes</div>
          </template>

        </div>
        <div class="col-6 panel-popover-display">
          <template v-if="isPanelRecutStopped">
            <strong>Recut Date</strong>
            <div>{{panel.recutDate | formatDateTime}}</div>
            <strong>Recut Reporting User</strong>
            <div>{{panel.recutReportingUser}}</div>
            <strong>Recut Labels</strong>
            <LabelTags :labelList="panel.labelList" class="mb-2" />
            <strong>Recut Notes</strong>
            <div v-html="convertNewlinesToBreaks(panel.recutNotes)"></div>
          </template>
          <template v-if="isPanelCancelled">
            <strong>Cancelled Reason</strong>
            <div v-html="convertNewlinesToBreaks(panel.cancelledReason)"></div>
          </template>
        </div>
      </div>
      <FormHorizontalRule v-if="showButtons" />
      <div class="row mt-1" v-if="showButtons">
        <div class="col-12">
          <ActionButton type="print" @click="displayOrderReprintPanelLabels" class="btn-sm mr-2" v-if="!isPanelRecutStopped"> Reprint Label</ActionButton>
          <ActionButton type="view" @click="displayProductionPanel" class="btn-sm" v-if="userHasReadPermission(PermissionTypes.ProductionPermissionTypes.production)"> View Panel</ActionButton>
        </div>
      </div>
    </div>
  </Popover>
</template>

<style scoped>
.production-preview-panel-popover {
  padding: 10px;
  font-size: 0.8rem;
  line-height: 1.1rem;
  min-width: 400px;
}
.panel-popover-display > div {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
</style>

<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'
import { ProductionPanelStatusTypes, ProductionPanelStatusTypeLookup, OptimiserSheetStatusTypes } from '@/store/types'

export default {
  name: 'OrderProductionPanelPopover',
  components: {
    Popover
  },
  props: {
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    barcode() {
      if(this.panel)
        return this.panel.barcode
      return ''
    },
    isPanelRecutStopped() {
      return this.panel.status == ProductionPanelStatusTypes.recut
    },
    isPanelCancelled() {
      return this.panel.status == ProductionPanelStatusTypes.cancelled
    },
    isPanelCompleted() {
      return this.panel.status == ProductionPanelStatusTypes.completed
    },
    tougheningBatch() {
      if(this.panel && this.panel.tougheningBatchPanels.length > 0)
        return this.panel.tougheningBatchPanels[0].tougheningBatch
      return null
    },
    optimiserSheet() {
      if(this.panel.optimiserSheetAllocations) {
        var validAlloc = this.panel.optimiserSheetAllocations.find(alloc => alloc.optimiserSheet && alloc.optimiserSheet.status != OptimiserSheetStatusTypes.cancelled)
        if(validAlloc)
          return validAlloc.optimiserSheet
      }
      return null
    },
  },
  data() {
    return {      
      orderItem: null,
      panel: null
    }
  },
  created() {
    this.ProductionPanelStatusTypeLookup = ProductionPanelStatusTypeLookup
  },
  methods: {
    displayFromElement(element, orderItem, panel) {
      this.orderItem = orderItem
      this.panel = panel

      this.$refs.panelPopover.displayFromElement(element)
    },
    displayOrderReprintPanelLabels() {
      let labelURL = `/orders/${this.panel.orderId}/panellabels/${this.panel.id}`

      var printParams = { download: this.isDesktopAppMode(), label: true, reprint: false }

      var params = $.param(printParams)
      this.$apiService.reportingService.generateReportSignedURL(`${labelURL}?${params}`)
      .then(response => {
        window.location.href = response.data.url
      })
    },
    displayProductionPanel() {
      this.$router.push(`/production/panels/${this.panel.id}`)
    }
  }
}
</script>